import React from 'react';

export const LogoFacebook = () => (
    <svg
        width="13px"
        height="24px"
        viewBox="0 0 13 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Facebook icon</title>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-1029.000000, -609.000000)" fill="#FFFFFF">
                <g>
                    <g transform="translate(120.000000, 593.000000)">
                        <g transform="translate(812.000000, 12.000000)">
                            <g transform="translate(88.000000, 0.000000)">
                                <g>
                                    <path d="M21.0978333,17.053 L21.6666667,12.787 L17.3333333,12.787 L17.3333333,10.063 C17.3333333,8.827 17.5618333,7.9855 19.3333333,7.9855 L21.7968333,7.9855 L21.7968333,4.168 C21.4053333,4.117 20.0658333,4 18.5043333,4 C15.2478333,4 13.0173333,5.989 13.0173333,9.64 L13.0173333,12.787 L9.33333333,12.787 L9.33333333,17.053 L13,17.053 L13,28 L17.3333333,28 L17.3333333,17.053 L21.0978333,17.053 Z" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
